var getTooltipConfig = function getTooltipConfig(fbFieldMetadata) {
  var safeFieldMetadata = fbFieldMetadata || {};
  var tooltipText = safeFieldMetadata["tooltip_text"];
  var tooltipTitle = safeFieldMetadata["tooltip_title"];
  var tooltipContainer = safeFieldMetadata["tooltip_container"];
  return !!tooltipText ? {
    placement: "top",
    desc: tooltipText,
    title: tooltipTitle,
    tooltipContainer: tooltipContainer
  } : false;
};
export default getTooltipConfig;